<template>
  <div class="container">
    <div class="secContainer">
      <div class="task-base">
        <van-row class="p-t-15" align="center" justify="center">
          <van-col span="3">
            <van-icon name="revoke" size="30" @click="rtList" color="#FFDA3E"/>
          </van-col>
          <van-col span="19">
            <div>
              <span class="task-title">{{ taskForm.taskName }}</span>
            </div>
          </van-col>
        </van-row>

        <van-row v-if="taskForm.createName && taskForm.createTime" type="flex" class="p-t-15" align="center"
                 justify="center">
          <van-col span="18">
            <div>
              <span class="row-name">{{ taskForm.createName }}创建于{{ taskForm.createTime }}</span>
            </div>
          </van-col>
          <van-col span="4">
            <div>
              <van-tag class="task-state wks" size="small" v-if="taskForm.status == 0" mark
                       type="primary">未开始
              </van-tag>
              <van-tag class="task-state ywc" size="small" v-if="taskForm.status == 2" mark
                       type="primary">已完成
              </van-tag>
              <van-tag class="task-state jxz" size="small" v-if="taskForm.status == 1" mark
                       type="primary">进行中
              </van-tag>
              <van-tag class="task-state yzz" size="small" v-if="taskForm.status == 3" mark
                       type="primary">已中止
              </van-tag>
            </div>
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-around" class="row-info">
          <van-col span="4">
            <div class="row-name">关联项目</div>
          </van-col>
          <van-col span="16">
            <div class="row-value">{{ taskForm.projectName }}</div>
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-around" class="row-info">
          <van-col span="4">
            <div class="row-name">执行人</div>
          </van-col>
          <van-col span="16">
            <div class="row-value">{{ taskForm.executorName }}</div>
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-around" class="row-info">
          <van-col span="4">
            <div class="row-name">任务进度</div>
          </van-col>
          <van-col span="16">
            <van-progress color="#FFDA3E" :percentage="taskForm.progress?taskForm.progress:0"
                          stroke-width="8"/>
          </van-col>
        </van-row>
        <van-divider/>
        <van-row type="flex" justify="space-around" class="row-info">
          <van-col span="4">
            <div class="row-name">计划起止时间</div>
          </van-col>
          <van-col span="16">
            <div class="row-value">{{ taskForm.planStartTime }}{{
                taskForm.planEndTime == null ? '' : '至' +
                    taskForm.planEndTime
              }}
            </div>
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-around" class="row-info">
          <van-col span="4">
            <div class="row-name">实际执行时间</div>
          </van-col>
          <van-col span="16">
            <div class="row-value">{{ taskForm.startTime }}{{
                taskForm.endTime == null ? '' : '至' +
                    taskForm.endTime
              }}
            </div>
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-around" class="row-info">
          <van-col span="4">
            <div class="row-name">上级任务</div>
          </van-col>
          <van-col span="16">
            <div class="row-value">{{ taskForm.parentName == null ? '无' : taskForm.parentName }}</div>
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-around" class="row-info">
          <van-col span="4">
            <div class="row-name">前置任务</div>
          </van-col>
          <van-col span="16">
            <div class="row-value">{{ taskForm.predependence == null ? '无' : taskForm.predependence }}</div>
          </van-col>
        </van-row>
      </div>
      <div class="interval-word" v-if="feedbackList.length != 0">
        <span>历史反馈记录</span>
      </div>
      <div class="task-base" v-if="feedbackList.length != 0">
        <van-tabs v-model="feedbackTab" sticky color="#FFDA3E" @click="feedbackTabClick">
          <van-tab :name="0" title="我的反馈"></van-tab>
          <van-tab :name="1" title="全部反馈"></van-tab>
        </van-tabs>

        <van-row align="center" v-for="item in feedbackList" :key="item.id" class="p-b-20">
          <van-col span="24">
            <van-row class="feedback-title-row" type="flex" align="center" justify="center">
              <van-col span="6">
                <div>
                  <span class="row-name">是否补录</span>
                </div>
              </van-col>
              <van-col span="16">
                <div>
                  <van-tag size="medium" v-if="item.blFlag == 'Y'" plain type="primary">是</van-tag>
                  <van-tag size="medium" v-if="item.blFlag == 'N'" plain type="danger">否</van-tag>
                </div>
              </van-col>
            </van-row>
            <van-row type="flex" align="center" justify="center">
              <van-col span="6">
                <div>
                  <span class="row-name">反馈人</span>
                </div>
              </van-col>
              <van-col span="16">
                <div>
                  <span class="row-value">{{ item.executorName }}</span>
                </div>
              </van-col>
            </van-row>
            <van-row type="flex" align="center" justify="center">
              <van-col span="6">
                <div>
                  <span class="row-name">反馈工时</span>
                </div>
              </van-col>
              <van-col span="16">
                <div>
                  <span class="row-value">{{ item.hour }}小时</span>
                </div>
              </van-col>
            </van-row>
            <van-row type="flex" align="center" justify="center">
              <van-col span="6">
                <div>
                  <span class="row-name">反馈时间</span>
                </div>
              </van-col>
              <van-col span="16">
                <div>
                  <span class="row-value">{{ item.createTime }}</span>
                </div>
              </van-col>
            </van-row>
            <van-row type="flex" align="center" justify="center">
              <van-col span="6">
                <div>
                  <span class="row-name">进度</span>
                </div>
              </van-col>
              <van-col span="16">
                <div>
                  <van-progress color="#FFDA3E" :percentage="item.progress?item.progress:0"
                                stroke-width="8"/>
                </div>
              </van-col>
            </van-row>
            <van-row type="flex" align="center" justify="center">
              <van-col span="6">
                <div>
                  <span class="row-name">完成情况</span>
                </div>
              </van-col>
              <van-col span="16">
                <div>
                  <span class="row-value-small">{{ item.message }}</span>
                </div>
              </van-col>
            </van-row>
               <!-- <van-row type="flex" justify="space-around" class="row-info">
           <van-field :value.prop="item.fileList" class="noAfterBorder" input-align="right" name="fj"  label="反馈附件" placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="true" :uploaderBtnShow="false"  :files="item.fileList"></uploadFiles>
          </template>
        </van-field>
        </van-row> -->
            <van-row type="flex" align="col-top" justify="center">
              <van-col span="6">
                <div>
                  <span class="row-name">反馈附件</span>
                </div>
              </van-col>
              <van-col span="16" class="p-0">
                <van-field :value.prop="item.fileList" class="noAfterBorder p-l-0  p-r-0 fileValueBox" input-align="right" name="fj" >
                  <template #input>
                    <uploadFiles moduleType="taskFeedback"  :disabled="true" :uploaderBtnShow="false"  :files="item.fileList"></uploadFiles>
                  </template>
                </van-field>
                <!-- <div v-if="item.fileList.length > 0">
                  <div style="display: flex;flex-wrap: wrap;">
                    <van-image
                        v-for="(ite, ind) in item.imageFileList" :key="ind+1"
                        style="margin-top: 5px;margin-right: 5px;"
                        width="100"
                        height="100"
                        :src="ite.fileURL"
                        @click="viewImg(item, ite)"
                    />
                  </div>
                  <div class="text-left font-28 m-t-16 cor-4185EE" v-for="(i,index) in item.docFileList" :key="index" @click="viewImg(item, i)">{{ i.fileName || i.name }}</div>
                </div> -->
              </van-col>
            </van-row>
          </van-col>
        </van-row>
      </div>
      <div class="interval-word" v-if="commentList.length != 0">
        <span>员工评论</span>
      </div>
      <div class="task-base" v-if="commentList.length != 0">
        <van-row>
          <van-col span="24" v-for="(item, index) in commentList" :key="index">
            <van-row justify="center" type="flex" align="center" class="text-center">
              <van-col span="4">
                <van-icon class="m-t-10" name="https://b.yzcdn.cn/vant/icon-demo-1126.png"/>
              </van-col>
              <van-col span="20">
                <van-row class="text-center">
                  <van-col span="4">
                    <span class="row-value">{{ item.createName }}</span>
                  </van-col>
                  <van-col span="8">
                  </van-col>
                  <van-col span="12">
                                        <span class="row-name">{{
                                            parseTime(item.createTime, '{y}-{m}-{d} {h}:{i}')
                                          }}</span>
                  </van-col>
                </van-row>
                <van-row class="text-left m-l-10">
                  <van-col span="20">
                    <span class="row-name-small">{{ item.message }}</span>
                  </van-col>
                </van-row>
              </van-col>
            </van-row>
            <van-divider class="divider-small"></van-divider>
          </van-col>
        </van-row>


      </div>
      <!--  站位盒子  -->
      <div class="h-170"></div>
      <div class="comment-input">
        <van-cell-group class="flex row-center col-center">
          <div class="font-32 p-l-20" @click="deptUserTreeAll.show = true">@</div>
          <van-popup v-model="deptUserTreeAll.show" get-container="body" position="bottom">
            <van-nav-bar left-text="取消" right-text="确定" title="选择人员"
                         @click-left="deptUserTreeAll.show = false" @click-right="commentPopupSubmit"
            />
            <van-search v-model="deptUserTreeAll.filterText" clearable shape="round"
                        @input="treeSearch($event, $refs.tree)"
            />
            <div class="h-vh-50" style="overflow-y: auto">
              <div class="p-10">
                <el-tree ref="tree" :data="deptUserTreeAll.data" :filter-node-method="filterNode" check-on-click-node
                         check-strictly node-key="uuid" show-checkbox
                />
              </div>
            </div>
          </van-popup>

          <van-field  :border="true" v-model="commentForm.message" center clearable type="textarea" autosize
                     placeholder="请输入评论内容" class="p-l-26 p-r-20 p-t-20 p-b-20 messageBox">
            <template #button>
              <van-button @click="sendComment" size="small" icon="comment-o" round
                          type="primary">发送
              </van-button>
            </template>
          </van-field>
        </van-cell-group>
        <!-- <van-textarea v-model="commentContent" style="width:100%" placeholder="请输入评论内容"></van-textarea>
<van-button  color="primary">发送</van-button> -->
      </div>
    </div>
  </div>
</template>
<script>
import {Cell, Col, ImagePreview, Row, Toast} from 'vant';
import {getCommentListAPI, getFeedbackListAPI, getTaskDetailsAPI, saveCommentAPI} from '@/api/task.js';
import mixin from '@/mixin/flow'
import uploadFiles from "@/components/uploadFiles/index.vue";
import {getDeptUserTreeAll} from '@/api/user.js'
import * as ww from "@wecom/jssdk";

export default {
  mixins: [mixin],
  components: {
    'van-row': Row,
    'van-col': Col,
    'van-cell': Cell,
    [ImagePreview.Component.name]: ImagePreview.Component,uploadFiles
  },
  data() {
    return {
      taskId: '',
      // 拜访数据
      visitData: {},
      fileList: [],
      loginUser: {},
      feedbackTab: 0,
      feedbackList: [],
      taskForm: {},
      commentList: [],
      commentForm: {
        message: '',
        taskId: '',
        userInfo: []
      },
      // 部门用户树
      deptUserTreeAll: {
        data: [],
        filterText: '',
        show: false
      },
    };
  },
  created() {
    this.taskId = this.$route.query.taskId
    const user = JSON.parse(sessionStorage.getItem('userInfo'));
    this.loginUser = user
    this.commentForm.taskId = this.taskId;
    this.getDataDetails()
    this.getDeptUserTreeAll()
  },
  methods: {
    // 人员、部门树
    getDeptUserTreeAll() {
      getDeptUserTreeAll().then(res => {
        // 递归处理this.deptUserTreeAll，添加禁用状态和uuid
        const data = this._getDeptUserTreeAll(res.data[0].children)
        this.$nextTick(() => {
          this.$set(this.deptUserTreeAll, 'data', data)
        })
      })
    },
    commentPopupSubmit() {
      let comment = ''
      const data = this.$refs.tree.getCheckedNodes()
      // 去重
      const existingUserIds = this.commentForm.userInfo.map(user => user.id);
      const uniqueData = data.filter(item => !existingUserIds.includes(item.id));
      this.commentForm.userInfo.push(...uniqueData)
      uniqueData.forEach(item => {
        comment += ('@' + item.label)
      })
      this.commentForm.message += comment
      this.deptUserTreeAll.show = false
    },
    rtList() {
      this.$router.go(-1)
    },
    // 发表评论
    sendComment() {
      if (this.commentForm.message.trim() == '') {
        Toast.fail("请输入评论内容");
      } else {
        saveCommentAPI(this.commentForm).then(res => {
          if (res.code == 200) {
            Toast.success("评论成功");
            this.commentForm.message = '';
            this.getCommentList();
          }
        })
      }
    },
    // 切换反馈查询类型tab
    feedbackTabClick(item) {
      if (item == 0) {
        this.getFeedbakList(this.loginUser.userId);
      } else {
        this.getFeedbakList();
      }
    },
    /**
     *  查询客户拜访记录详情
     */
    getDataDetails() {
      this.getTaskDetails();
      this.getFeedbakList(this.loginUser.userId);
      this.getCommentList();
    },
    /**
     * 查询任务基础信息
     */
    getTaskDetails() {
      getTaskDetailsAPI(this.taskId).then(res => {
        if (res.code == 200) {
          this.taskForm = res.data
        }
      })
    },
    /**
     * 查询任务反馈记录
     */
    getFeedbakList(userId) {
      let queryData = {};
      queryData.executorId = userId
      queryData.taskId = this.taskId;
      getFeedbackListAPI(queryData).then(res => {
        if (res.code == 200) {
          this.feedbackList = res.rows;
          console.log(res.rows) 
          // res.rows.forEach(item => {
          //   this.$set(item, 'imageFileList', [])
          //   this.$set(item, 'docFileList', [])
          //   // item.fileList.forEach(fileItem => {
          //   //   if (this.imageTypeList.includes(fileItem.fileType)) {
          //   //     item.imageFileList.push(fileItem)
          //   //   } else if (this.documentTypeList.includes(fileItem.fileType)) {
          //   //     item.docFileList.push(fileItem)
          //   //   }
          //   // })
          // })
        }
      })
    },
    /**
     * 查询评论列表
     */
    getCommentList() {
      let queryData = {};
      queryData.taskId = this.taskId;
      getCommentListAPI(queryData).then(res => {
        if (res.code == 200) {
          this.commentList = res.rows;
        }
      })
    },
    // viewImg(parentItem, item) {
    //   if (this.imageTypeList.includes(item.fileType)) {
    //     ImagePreview({
    //       images: parentItem.imageFileList.map(i => i.fileURL),
    //       closeable: true
    //     });
    //   } else {
    //     if (this.$store.state.user.environmentType === 1) {
    //       this.registerWw().then(() => {
    //         console.log('registerWw completed, calling filePreview');
    //         ww.previewFile({
    //           url: item.previewUrl, // 需要预览文件的地址(必填，可以使用相对路径)
    //           name: item.name, // 需要预览文件的文件名，必须有带文件格式的后缀，例如.doc(不填的话取url的最后部分，最后部分是个包含格式后缀的文件名)
    //           size: item.fileSize,// 需要预览文件的字节大小(必填，而且大小必须正确，否则会打开失败)
    //         });
    //       }).catch((error) => {
    //         console.error('registerWw failed:', error);
    //         // 即使注册失败也尝试预览文件
    //         ww.previewFile({
    //           url: item.previewUrl, // 需要预览文件的地址(必填，可以使用相对路径)
    //           name: item.name, // 需要预览文件的文件名，必须有带文件格式的后缀，例如.doc(不填的话取url的最后部分，最后部分是个包含格式后缀的文件名)
    //           size: item.fileSize,// 需要预览文件的字节大小(必填，而且大小必须正确，否则会打开失败)
    //         });
    //       });
    //     } else {
    //       this.wwRegister(window.encodeURIComponent(location.href.split('#')[0]), ww => {
    //         ww.previewFile({
    //           url: item.previewUrl, // 需要预览文件的地址(必填，可以使用相对路径)
    //           name: item?.name,
    //           size: item.fileSize,
    //           success: function (res) {
    //             console.log('成功打开附件API', res)
    //           },
    //           fail: function (res) {
    //             console.log('打开附件API失败', res)
    //             // 在这里处理失败的情况，例如提示用户或进行其他操作
    //           }
    //         })
    //       })
    //     }
    //   }
    // },
    parseTime(time, pattern) {
      if (arguments.length === 0 || !time) {
        return null;
      }
      const format = pattern || "{y}-{m}-{d} {h}:{i}:{s}";
      let date;
      if (typeof time === "object") {
        date = time;
      } else {
        if (typeof time === "string" && /^[0-9]+$/.test(time)) {
          time = parseInt(time);
        } else if (typeof time === "string") {
          time = time.replace(new RegExp(/-/gm), "/");
        }
        if (typeof time === "number" && time.toString().length === 10) {
          time = time * 1000;
        }
        date = new Date(time);
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
      };
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        // Note: getDay() returns 0 on Sunday
        if (key === "a") {
          return ["日", "一", "二", "三", "四", "五", "六"][value];
        }
        if (result.length > 0 && value < 10) {
          value = "0" + value;
        }
        return value || 0;
      });
      return time_str;
    }
  }

};
</script>
<style scoped>

.container {
  background-color: rgb(246, 246, 246);
  /* position: relative; */
}

.row-info {
  margin-bottom: 16px;
  margin-top: 20px;
}

.row-name {
  font-size: 28px;
  color: #969799;
}

.row-name-small {
  font-size: 28px;
  color: #969799;
  display: inline-block;
  line-height: 150%;
}

.row-value {
  text-align: left;
  font-size: 28px;
  color: #000000;
  /* display:inline-block;
  line-height: 150%; */
}

.row-value-small {
  text-align: left;
  font-size: 28px;
  color: #000000;
  display: inline-block;
  line-height: 150%;
}

.task-title {
  font-size: 28px;
  font-weight: 550;
  display: inline-block;
}

.task-base {
  margin: 10px 10px 10px 10px;
  border-radius: 20px;
  background-color: rgb(255, 255, 255);
}

.interval-word {
  margin: 30px;
  font-size: 34px;
  font-weight: 600;
}

.feedback-title-row {
  margin-top: 15px;
  border-top: 0.1px solid #dfc9c9;
}

.comment-input {
  position: absolute; /* 绝对定位 */
  top: 90%; /* 设置距离顶部的位置 */
  z-index: 10;
  margin: 10px 10px 0 10px;
  height: 10%;
  background-color: rgb(255, 255, 255);
  width: 97%
}



.completed-stamp {
  position: absolute;
  top: 0px; /* 位置可以根据需要调整 */
  right: 0px; /* 位置可以根据需要调整 */
  z-index: 10; /* 确保图标位于van-row之上 */
}

.wks {
  background-color: rgba(77, 75, 75, 0.3);
}

.ywc {
  background-color: rgba(134, 99, 3, 0.5);
}

.jxz {
  background-color: rgba(131, 189, 6, 0.5);
}

.yzz {
  background-color: rgba(255, 70, 52, 0.5);
}

.secContainer {
  width: 100wh;
  height: 99vh;
}

.divider-small {
  margin: 5px 0;
  transform: scale(1, 3);
}
</style>
<style>
.messageBox .van-field__control{
  background-color: #fff5f5;
} 
</style>
